/* unplugin-vue-components disabled */import script from "./mg-query-filter-dropdown.vue?vue&type=script&lang=jsx&setup=true"
export * from "./mg-query-filter-dropdown.vue?vue&type=script&lang=jsx&setup=true"

import "./mg-query-filter-dropdown.vue?vue&type=style&index=0&id=5d325cca&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d325cca"]])

export default __exports__